module.exports = __webpack_public_path__ + "static/media/Investigate.6d572498.svg";